module.exports = __webpack_public_path__ + "static/media/hemisphere.6da8f862.svg";